import React, { useMemo } from 'react';
import { gql, useQuery } from '@apollo/client';
import ManageAgeGroupContainer from './manage-age-group.container';
import { getCurrMember } from '../../../lib/services/member.service';
import { providedMemberHasAnyRoles } from '../../../lib/services/user.service';
import { ROLES } from '../../../../_configuration';

const GET_MANAGE_AGE_GROUP = gql`
  query GetManageAgeGroupGraphQL($ageGroupId: ID!) {
    ageGroup(_id: $ageGroupId) {
      _id
      assessmentId
      name
      numSessions
      numPlayers
      currentStageNum
      currentStage {
        _id
        type
        config
        endsAt
        order
        isReady
      }
      nextStage {
        _id
        type
        config
        order
      }
    }
  }
`;

interface IManageAgeGroupGraphQL {
  ageGroupId: string;
}

export const ManageAgeGroupGraphQL: React.FC<IManageAgeGroupGraphQL> = ({ ageGroupId }) => {
  const { data, loading, error } = useQuery(GET_MANAGE_AGE_GROUP, {
    skip: !ageGroupId,
    variables: { ageGroupId },
    fetchPolicy: 'cache-and-network'
  });

  const { member, loading: memberLoading } = getCurrMember();
  const ageGroup: IAgeGroup | undefined = data?.ageGroup;
  const allowed = useMemo(() => Boolean(ageGroup && providedMemberHasAnyRoles({
    member, roles: [ROLES.CONFIGURATION], ageGroupId: ageGroup._id, assessmentId: ageGroup.assessmentId,
  })), [member, ageGroup]);

  return <ManageAgeGroupContainer
    ageGroup={allowed ? ageGroup : undefined}
    loading={loading || (memberLoading && !member)}
    fetchError={Boolean(error)}
  />;
};
